import { render, staticRenderFns } from "./maoIndex.vue?vue&type=template&id=0868d570&"
import script from "./maoIndex.vue?vue&type=script&lang=js&"
export * from "./maoIndex.vue?vue&type=script&lang=js&"
import style0 from "./maoIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports